import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { ServerPath } from '../../shared/constants';
import axios from 'axios';
import toast from 'react-hot-toast';

import AOS from "aos";
import "aos/dist/aos.css";

const styles = {

  containerForm: {
    width : '100%',
    backgroundColor: '#FFF',
    borderRadius: '25px 25px 0 0',
    position : 'fixed',
    bottom : 0,
    flex: 1,
    padding: '4%',
  },
  title: {
    fontSize: 20,
    color : '#000',
  },
  input: {
    width: '100%',
    backgroundColor : '#FFF',
    height: 50,
    borderWidth: '0 0 1px',
    paddingLeft: 10,
    fontSize: 16,
    marginBottom: 16,
    
  },
  inputcode: {
    width: '60%',
    backgroundColor : '#FFF',
    height: 50,
    borderWidth: '0 0 1px',
    paddingLeft: 10,
    fontSize: 16,
    marginBottom: 16,
    
  },
  subTitle: {
    fontSize: '16px',
    color: '#a1a1a1',
    marginBottom: '1rem',
  },
  button: {
    width: '60%',
    marginLeft : '20%',
    fontSize: '18px',
    backgroundColor: '#9744ED',
    borderRadius: '10px',
    border : 0,
    padding: '8px',
    color: '#FFF',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginBottom: '2rem',
    textAlign : 'center',
  },
  codebutton: {
    width: '20%',
    marginLeft : '20%',
    fontSize: '18px',
    backgroundColor: '#9744ED',
    borderRadius: '10px',
    border : 0,
    padding: '8px',
    color: '#FFF',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginBottom: '2rem',
    textAlign : 'center',
  },
};

const ForgotPassword = () => {

  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [repassword, setRePassword] = useState('');
  const [code, setCode] = useState('');

  useEffect(() => {
    AOS.init();
  }, []);

  const onSubmit = (event) => {
    event.preventDefault();

    if (code === '') {
      toast.error('Code is Empty');
      return;
    }
    if (password=== '') {
      toast.error('New Password is Empty');
      return;
    }

    if (password !== repassword) {
      toast.error('Password and Password Confim is different');
      return;
    }

    axios
    .post(ServerPath + "/auth/verify", { email : email, password: password, token : code, type : 'password' })
    .then((data) => {
      if (data.data.status) {
        toast.success('Password is changed, Please Login');       
        navigate('/login')
      } else if (data.data.code ==='token') {
         toast.error('Code is not Valid');
      } else {
        toast.error('error');
      }
    })
    .catch((err) => {
      console.log(err);
    });

  };

  const getCode = () =>{
    if (email ==='') {
      toast.error('Input Your Email');
      return;
    } 
  
    axios
      .post(ServerPath + "/auth/send", { email : email })
      .then((data) => {
        if (data.data.status) {
          toast.success('Code is sended, Check your email');
        } else if (data.data.code ==='invalid') {
            toast.error('Email is not Valid');
        } else {
            toast.error('error');
        }
      })
      .catch((err) => {
        console.log(err);
      });
      
  }
  
  const linkTo = (link) => {
    navigate('/' + link);
  }
  return  (
    <div className="container">
      <div className="toptitle" >
        <span onClick={() =>linkTo('welcome')}>
          <i className="fa-solid fa-arrow-left"></i>
        </span>
        <span>SignIn</span>
      </div>
      <div id="forgot_welcome" className="welcome" data-aos="fade-right">
        Welcome
      </div>


      <div style={styles.containerForm} data-aos="fade-down" data-aos-duration="1400" data-aos-anchor-placement="center-bottom" >
        <label className="usertitle">아이디(이메일)</label>
        <input 
          style={styles.input} 
          placeholder="이메일"
          value={email} 
          onChange={e => setEmail(e.target.value)}
        />

        <label className="usertitle">새로운 패스워드</label>
        <input
          style={styles.input}
          placeholder="패스워드"
          value={password}
          onChange={e => setPassword(e.target.value)}
          type="password"
        />

        <label className="usertitle">패스워드 확인</label>
        <input
          style={styles.input}
          placeholder="패스워드"
          value={repassword}
          onChange={e => setRePassword(e.target.value)}
          type="password"
        />

        <label style={styles.title}>코드</label><br/>
        <input
          style={styles.inputcode}
          placeholder="코드"
          value={code}
          onChange={e => setCode(e.target.value)}
          type="text"
        />
        <button onClick={getCode} style={styles.codebutton}>
          코드 발송
        </button>


        <button onClick={onSubmit} style={styles.button}>
          비밀번호 변경
        </button>

      </div>
    </div>
  );
};

const mapStateToProps = ({ authUser }) => {
  const { loading, error } = authUser;
  return { loading, error };
};

export default connect(mapStateToProps, {
})(ForgotPassword);


